import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteReceipt = ({
    setIsDeleteReceipt,
    selectedData,
    deleteReceiptLoading,
    deleteReceiptMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deleteReceiptMutate({
            receiptId: selectedData?.id,
        });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteReceipt}
            title="Confirm Deletion"
        >
            <WarningText>
                Are you sure you want to delete the invoice for ‘{selectedData?.ownerName}’?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteReceiptLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteReceiptLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteReceipt;